import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate, Link } from 'react-router-dom';
import AdminSubmissions from './components/AdminSubmissions';
import AdminNewsletterSignups from './components/AdminNewsletterSignups';
import AdminSendNewsletter from './components/AdminSendNewsletter';
import AdminCleanArchive from './components/AdminCleanArchive';
import AdminDebugNewsletters from './components/AdminDebugNewsletters';

const Sidebar = ({ onLogout }) => (
  <div style={{
    width: 220,
    minHeight: '100vh',
    background: '#f5f5f5',
    padding: '2rem 1rem',
    boxSizing: 'border-box',
    borderRight: '1px solid #ddd',
    position: 'fixed',
    top: 0,
    left: 0
  }}>
    <h2 style={{ fontSize: 18, marginBottom: 8, color: '#2a4d69', letterSpacing: 1 }}>Niaarav Nonprofit</h2>
    <div style={{ fontSize: 20, marginBottom: 32, fontWeight: 600 }}>Admin</div>
    <nav style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Link to="/admin/dashboard" style={{ textDecoration: 'none', color: '#333', fontWeight: 500 }}>Dashboard</Link>
      <Link to="/admin/submissions" style={{ textDecoration: 'none', color: '#333' }}>Contact Submissions</Link>
      <Link to="/admin/newsletter" style={{ textDecoration: 'none', color: '#333' }}>Newsletter Signups</Link>
      <Link to="/admin/send-newsletter" style={{ textDecoration: 'none', color: '#333' }}>Send Newsletter</Link>
      <Link to="/admin/clean-archive" style={{ textDecoration: 'none', color: '#333' }}>Clean Archive</Link>
      <Link to="/admin/debug-newsletters" style={{ textDecoration: 'none', color: '#333' }}>Debug Newsletters</Link>
      <button onClick={onLogout} style={{ marginTop: 32, padding: 8, background: '#eee', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Logout</button>
    </nav>
  </div>
);

const Dashboard = () => (
  <div style={{ padding: 32 }}>
    <h2>Niaarav Nonprofit Admin Dashboard</h2>
    <p>Welcome! Use the sidebar to manage submissions and newsletter signups.</p>
  </div>
);

const Admin = () => {
  const [password, setPassword] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    if (!password) {
      setError('Please enter the admin password.');
      setLoading(false);
      return;
    }
    // Validate password by making a test request to the protected API
    try {
      const res = await fetch('/api/admin_submissions', {
        headers: { 'x-admin-password': password },
      });
      if (res.status === 401) {
        setError('Incorrect password.');
        setLoading(false);
        return;
      }
      if (!res.ok) throw new Error('Failed to validate password');
      setAuthenticated(true);
      setLoading(false);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Error validating password.');
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setAuthenticated(false);
    setPassword('');
    setError('');
    navigate('/admin');
  };

  if (!authenticated) {
    return (
      <div style={{ maxWidth: 400, margin: '2rem auto', padding: 20, border: '1px solid #ccc', borderRadius: 8 }}>
        <h2>Niaarav Nonprofit Admin Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Enter admin password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: '100%', padding: 8, marginBottom: 12 }}
            disabled={loading}
          />
          <button type="submit" style={{ width: '100%', padding: 8 }} disabled={loading}>
            {loading ? 'Validating...' : 'Login'}
          </button>
        </form>
        {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar onLogout={handleLogout} />
      <div style={{ marginLeft: 220, width: '100%' }}>
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="submissions" element={<AdminSubmissions password={password} />} />
          <Route path="newsletter" element={<AdminNewsletterSignups password={password} />} />
          <Route path="send-newsletter" element={<AdminSendNewsletter password={password} />} />
          <Route path="clean-archive" element={<AdminCleanArchive password={password} />} />
          <Route path="debug-newsletters" element={<AdminDebugNewsletters password={password} />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Admin; 